import React from 'react';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-32 pb-12 px-6 border-t-[12px] border-transparent" style={{ borderImage: 'linear-gradient(to right, #22d3ee, #d946ef, #facc15) 1' }}>
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-32">
          
          <div className="lg:col-span-5">
            <h2 className="text-6xl md:text-8xl font-black mb-8 tracking-tighter leading-none uppercase">Join The<br/><span className="prism-text">Spectrum.</span></h2>
            <p className="text-gray-400 text-xl mb-12 max-w-md leading-relaxed">Subscribe for priority access to studio drops, exclusive lens colorways, and insider optics reports.</p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <input 
                type="email" 
                placeholder="YOUR EMAIL ADDRESS" 
                className="bg-transparent border-b-2 border-gray-800 px-0 py-4 focus:outline-none focus:border-white transition-all w-full text-lg font-bold uppercase tracking-widest"
              />
              <button className="font-black text-xs tracking-[0.3em] border-2 border-white px-10 py-4 hover:bg-white hover:text-black transition-all uppercase flex-shrink-0">
                JOIN
              </button>
            </div>
          </div>
          
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-12">
            <div>
              <h4 className="font-black mb-8 tracking-[0.3em] text-[10px] text-gray-600 uppercase">STUDIO ACCESS</h4>
              <ul className="space-y-5 text-sm font-bold uppercase tracking-widest">
                <li><a href="#" className="hover:prism-text transition-all">Latest Drops</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Lens Lab</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Fit Matrix</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Care Guide</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-black mb-8 tracking-[0.3em] text-[10px] text-gray-600 uppercase">SUPPORT</h4>
              <ul className="space-y-5 text-sm font-bold uppercase tracking-widest">
                <li><a href="#" className="hover:prism-text transition-all">Help Center</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Shipping</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Returns</a></li>
                <li><a href="#" className="hover:prism-text transition-all">Contact</a></li>
              </ul>
            </div>

            <div className="col-span-2 md:col-span-1">
              <h4 className="font-black mb-8 tracking-[0.3em] text-[10px] text-gray-600 uppercase">CONNECT</h4>
              <div className="flex gap-6">
                <a href="#" className="w-12 h-12 border border-gray-800 flex items-center justify-center hover:border-white hover:prism-text transition-all">
                  <SafeIcon icon={FiIcons.FiInstagram} className="text-xl" />
                </a>
                <a href="#" className="w-12 h-12 border border-gray-800 flex items-center justify-center hover:border-white hover:prism-text transition-all">
                  <SafeIcon icon={FiIcons.FiTwitter} className="text-xl" />
                </a>
                <a href="#" className="w-12 h-12 border border-gray-800 flex items-center justify-center hover:border-white hover:prism-text transition-all">
                  <SafeIcon icon={FiIcons.FiYoutube} className="text-xl" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-[10px] font-black tracking-[0.3em] text-gray-600 border-t border-gray-900 pt-12 uppercase">
          <div className="flex flex-wrap justify-center gap-8 mb-8 md:mb-0">
            <span>&copy; {new Date().getFullYear()} PrismPeak Studio</span>
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
          <p className="text-center md:text-right" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;